import React from 'react';
import { Circle, G, Line, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** ACH = (Q × 60) / V_room — room volume L×W×H, supply diffuser, return grille, circulation arrows. */
export function DiagramAirChanges() {
  // Room (3D-ish perspective)
  const x = 60, y = 70, w = 220, h = 130;

  return (
    <DiagramCanvas>
      {/* Back wall (perspective) */}
      <Polygon points={`${x},${y} ${x + 22},${y - 18} ${x + w + 22},${y - 18} ${x + w},${y}`}
        fill={DT.fill} stroke={DT.stroke} strokeWidth="1" opacity={0.9} />
      <Polygon points={`${x + w},${y} ${x + w + 22},${y - 18} ${x + w + 22},${y + h - 18} ${x + w},${y + h}`}
        fill={DT.fill} stroke={DT.stroke} strokeWidth="1" opacity={0.9} />
      {/* Front face (room interior) */}
      <Rect x={x} y={y} width={w} height={h} fill={DT.fill} stroke={DT.stroke} strokeWidth="2" />

      {/* Supply diffuser (top) */}
      <Rect x={x + 28} y={y - 4} width={48} height={8} fill={DT.varColor} opacity={0.9} stroke={DT.stroke} strokeWidth="1" />
      {[0, 1, 2, 3].map(i => (
        <Line key={i} x1={x + 30 + i * 12} y1={y - 4} x2={x + 30 + i * 12} y2={y + 4}
          stroke={DT.bg} strokeWidth="0.8" />
      ))}
      {/* Supply jets (downward fanning) */}
      {[-1, -0.4, 0.2, 0.8].map((d, i) => {
        const sx = x + 52, sy = y + 6;
        const ex = sx + d * 30, ey = sy + 30;
        return (
          <G key={i}>
            <Line x1={sx} y1={sy} x2={ex} y2={ey} stroke={DT.arrow} strokeWidth="1.2" opacity={0.8} />
            <Polygon points={`${ex},${ey} ${ex - d * 4 - 2},${ey - 4} ${ex - d * 4 + 2},${ey - 4}`}
              fill={DT.arrow} opacity={0.8} />
          </G>
        );
      })}

      {/* Return grille (bottom right) */}
      <Rect x={x + w - 70} y={y + h - 4} width={50} height={8} fill={DT.fill} stroke={DT.stroke} strokeWidth="1" />
      {[0, 1, 2, 3].map(i => (
        <Line key={i} x1={x + w - 68 + i * 12} y1={y + h - 4} x2={x + w - 68 + i * 12} y2={y + h + 4}
          stroke={DT.stroke} strokeWidth="0.8" />
      ))}
      {/* Return arrow */}
      <Line x1={x + w - 45} y1={y + h - 30} x2={x + w - 45} y2={y + h - 7}
        stroke={DT.arrow} strokeWidth="1.5" />
      <Polygon points={`${x + w - 45},${y + h - 6} ${x + w - 49},${y + h - 13} ${x + w - 41},${y + h - 13}`}
        fill={DT.arrow} />

      {/* Circulation curl */}
      <Polygon points={`${x + w / 2 - 18},${y + 60} ${x + w / 2 - 24},${y + 56} ${x + w / 2 - 24},${y + 64}`} fill={DT.leader} opacity={0.6} />
      <Line x1={x + w / 2 - 18} y1={y + 60} x2={x + w / 2 + 30} y2={y + 60} stroke={DT.leader} strokeWidth="1" opacity={0.5} />

      {/* Dimension lines L (bottom) and H (left) */}
      <Line x1={x} y1={y + h + 18} x2={x + w} y2={y + h + 18} stroke={DT.dim} strokeWidth="1" />
      <Line x1={x} y1={y + h + 14} x2={x} y2={y + h + 22} stroke={DT.dim} strokeWidth="1" />
      <Line x1={x + w} y1={y + h + 14} x2={x + w} y2={y + h + 22} stroke={DT.dim} strokeWidth="1" />
      <SvgText x={x + w / 2} y={y + h + 28} fill={DT.dim} fontSize="9" fontFamily={DT.mono} textAnchor="middle">L × W × H</SvgText>

      {/* Labels */}
      <LeaderLine x1={x + 52} y1={y - 2} x2={20} y2={50} varName="Q" desc="Supply (CFM)" anchor="start" />
      <LeaderLine x1={x + w / 2} y1={y + h / 2} x2={295} y2={70} varName="V" desc="Room volume (ft³)" anchor="end" />
      <LeaderLine x1={x + w - 45} y1={y + h - 8} x2={310} y2={210} varName="ACH" desc="changes / hour" anchor="end" />

      <FormulaTag formula="ACH = (Q · 60) / V_room    [V = L · W · H]" />
    </DiagramCanvas>
  );
}
